<template>
  <div>
    <h1>{{ get("heading-1") }}</h1>
    <h2>{{ get("heading-2") }}</h2>
    <v-row>
      <v-col cols="12" xl="8" lg="8" md="8" sm="12">
        <v-row>
          <v-col cols="12" xl="12" lg="12" md="12" sm="12">
            <v-img :src="image" class="image"></v-img>
          </v-col>
          <v-col cols="12" xl="12" lg="12" md="12" sm="12">
            <p>
              {{ get("p-2.1") }}
            </p>
          </v-col>
        </v-row>
        <v-row :class="theme + '-alt-background-1'">
          <v-col cols="12">
            <h2>{{ get("heading-3") }}</h2>
            <p>
              {{ get("p-3.1") }}
            </p>
            <ol>
              <li>
                <p>
                  <strong>{{ get("p-3.2") }}</strong> 
                  {{ get("p-3.3") }}
                </p>
              </li>
              <li>
                <p>
                  <strong>{{ get("p-3.4") }}</strong> 
                  {{ get("p-3.5") }}
                </p>
              </li>
              <li>
                <p>
                  <strong>{{ get("p-3.6") }}</strong> 
                  {{ get("p-3.7") }}
                </p>
              </li>
              <li>
                <p>
                  <strong>{{ get("p-3.8") }}</strong> 
                  {{ get("p-3.9") }}
                </p>
              </li>
            </ol>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <h2>
              {{ get("heading-4") }}
            </h2>
            <p>
              {{ get("p-4.1") }}
              {{ get("company") }} 
              {{ get("p-4.2") }}
            </p>
            <h2>
              {{ get("heading-5") }}
            </h2>
            <p>
              {{ get("p-5.1") }}
              {{get("company")}}
              {{ get("p-5.2") }} 
               <phonenumber phone="(719) 390-7663"></phonenumber>.
              {{ get("p-5.3") }}
            </p>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" xl="4" lg="4" md="4" sm="12">
        <estimate></estimate>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import estimate from "../../components/controls/estimate-ctrl";
import localizationMixin from "@/mixins/localization-mixin";
import phonenumber from "@/components/controls/phone-number";

export default {
  name: "Roofing-Signs",

  components: {
    estimate,
    phonenumber
  },

  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },

  created() {
    this.pageName = "roof-signs";
  },

  data: () => ({
    image: require("@/assets/shingles-2.jpg"),
  }),

  mixins: [localizationMixin],
  methods: {
    getLocalization() {    
    }
  },
};
</script>

<style lang="scss" scoped>
</style>
